/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { QueryClient } from "@tanstack/react-query";

import { getPastProductsQueryKey } from "./hooks/usePastProducts";

export const invalidatePastProducts = (queryClient: QueryClient, accountNumber: string) =>
  queryClient.invalidateQueries({
    queryKey: getPastProductsQueryKey(accountNumber),
  });
